import "@rainbow-me/rainbowkit/styles.css";

import { getDefaultConfig } from "@rainbow-me/rainbowkit";
import { mainnet, polygon, arbitrum, bsc, base } from "wagmi/chains";

const appName = "DEX Trading POC";

// Check for WalletConnect project ID in both common prefixes
const projectId =
  process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID ||
  process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID;

if (!projectId) {
  throw new Error(
    "WalletConnect projectId is required. Set either REACT_APP_WALLET_CONNECT_PROJECT_ID " +
      "or NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID environment variable.",
  );
}

export const chains = [bsc, mainnet, polygon, arbitrum, base]; // BSC first as default for PancakeSwap

export const config = getDefaultConfig({
  appName,
  projectId,
  chains,
  ssr: false,
});
